// Worthify i18n — FR locale. Keys must mirror locales/en.js;
// missing keys fall back to English in useTranslation.
export const fr = {
    // Header
    tagline: "Ça vaut vraiment le coup ?",
    
    // Main heading
    mainHeading: "Connaissez la vraie valeur !",
    heroSubtext: "Une vérification peut vous éviter une erreur coûteuse.",
    heroLine1: "Vérifiez n'importe quelle voiture en quelques secondes et évitez les erreurs coûteuses.",
    heroLine2: "Voyez les problèmes cachés avant d'acheter.",
    heroLine3: "Une vérification peut vous faire économiser des milliers.",
    
    // Input placeholders
    registrationPlaceholder: " ",
    pricePlaceholder: " ",
    priceHelperText: "Entrez le prix demandé pour comparer à la valeur réelle",
    listingUrlPlaceholder: "Entrez l'URL de l'annonce (optionnel)",
    vinPlaceholder: "ex. WAUZZZ4L1BD123456",
    vinHelperText: "Le VIN améliore la précision de l'analyse moteur et des risques",
    vinInvalid: "Format VIN invalide (doit contenir 17 caractères)",
    vinTooltip: "Le VIN aide à identifier le moteur exact et les problèmes cachés",
    vinPreviewLoading: "Décodage du VIN…",
    vinPreviewDetected: "Détecté",
    vinPreviewUnknown: "Impossible de décoder ce VIN — l'analyse fonctionnera quand même",
    regHelperText: "Entrez n'importe quel numéro d'immatriculation",
    ctaHelperText: "Vérifiez n'importe quel véhicule gratuitement",
    
    // Buttons
    analyzeButton: "VÉRIFIER MAINTENANT",
    checkingVehicle: "Vérification du véhicule...",
    trustText: "Sans inscription • Données réelles DVSA + DVLA • 🛡 More Than HPI Check • Verdict instantané",
    downloadButton: "Télécharger le rapport complet (seulement £1)",
    generatingPdf: "Génération du PDF...",
    newSearch: "← Nouvelle recherche",
    
    // Error messages
    errorEmptyRegistration: "Veuillez entrer une immatriculation de véhicule",
    errorVehicleNotFound: "Véhicule non trouvé. Veuillez vérifier le numéro d'immatriculation.",
    errorServiceUnavailable: "Service indisponible, veuillez réessayer.",
    errorReportFailed: "Échec de la génération du rapport. Veuillez réessayer.",
    
    // Results - Risk level
    riskLevel: "Niveau de risque",
    tickerFailedMots: "MOT ÉCHOUÉS",
    tickerMiles: "MILES",
    tickerDangerous: "DANGEREUX",
    verdictWorthBuying: "BONNE AFFAIRE",
    verdictBeCareful: "SOYEZ PRUDENT",
    verdictAvoid: "À ÉVITER",
    verdictExplanationLow: "Historique MOT propre. Achat sûr.",
    verdictShortExplanationLow: "L'historique semble propre. Inspectez avant de payer.",
    verdictShortExplanationMedium: "Problèmes connus dans l'historique. Seulement au bon prix.",
    verdictShortExplanationHigh: "Risques importants. Prévoyez le budget réparations — ou partez.",
    verdictShortExplanationScam: "Prix anormalement bas. À traiter comme un achat à haut risque.",
    verdictExplanationMedium: "Quelques problèmes détectés. Inspectez soigneusement.",
    verdictExplanationHigh: "Problèmes graves détectés. Risque élevé de réparations coûteuses.",
    verdictExplanationScam: "Cette offre est très suspecte. Évitez cet achat.",
    verdictSubtextLow: "Ce prix semble raisonnable par rapport à la valeur réelle.",
    verdictSubtextMedium: "Quelque chose ne va pas. Inspectez soigneusement avant d'acheter.",
    verdictSubtextHigh: "Problèmes graves détectés. Nous vous recommandons fortement d'éviter ce véhicule.",
    verdictSubtextScam: "Cette offre est très suspecte. Évitez cet achat.",
    redFlagsTitle: "Signaux d'alarme",
    noRedFlags: "Aucun signal d'alarme — historique propre",
    yourAskingPrice: "Prix demandé",
    marketMedianShort: "Valeur réelle",
    suspiciousPrice: "Suspect — en dessous du marché",
    unlockReportCta: "DÉBLOQUER LE RAPPORT DE RISQUE COMPLET — SEULEMENT £1",
    pdfButtonSubtext: "Risques cachés, coûts de réparation et levier de négociation à l'intérieur",
    pdfButtonSubtext2: "Enregistrez-le, partagez-le ou utilisez-le lors de l'achat",
    lossWarning: "Vous pourriez perdre {amount}",
    negotiationPowerTitle: "Pouvoir de Négociation",
    youCanNegotiate: "Vous pouvez négocier",
    expertScriptLabel: "Script de négociation d'expert",
    copyMessage: "Copier le message",
    confirmedMotIssues: "défauts MOT confirmés",
    expertSellerScript: "Bonjour — je suis vraiment intéressé par la voiture et prêt à agir rapidement. J'ai fait examiner l'historique MOT indépendamment par Worthify et le rapport identifie {target} de réparations immédiates et réalistes : {issues}. Ce ne sont pas des scénarios catastrophes — c'est le coût réel pour régler ce que le MOT montre déjà. Pour en tenir compte, j'aurais besoin d'une réduction de {target}.",
    expertSellerScriptClose: "Si nous pouvons nous entendre sur {finalPrice}, je peux tout finaliser aujourd'hui.",
    worthifyExpertsSuggest: "Les experts Worthify suggèrent de négocier",
    askingPriceLabel: "Prix demandé",
    realValueWorthifyLabel: "Valeur réelle (Worthify)",
    realValueGvdLabel: "Valeur de marché (registre DVLA)",
    navHome: "Accueil",
    navAbout: "À propos",
    navPricing: "Tarifs",
    navFaq: "FAQ",
    navContact: "Contact",
    scoreAdjustedBadge: "Mis à jour avec les données premium",
    penaltyLabel_theft: "Signalé volé (PNC)",
    penaltyLabel_finance: "Financement en cours",
    penaltyLabel_mileage_anomaly: "Anomalie de kilométrage",
    penaltyLabelWriteOff: "Perte totale enregistrée",
    penaltyLabelWriteOff_A: "Perte totale Cat A",
    penaltyLabelWriteOff_B: "Perte totale Cat B",
    penaltyLabelWriteOff_S: "Perte totale Cat S",
    penaltyLabelWriteOff_N: "Perte totale Cat N",
    penaltyLabelWriteOff_D: "Perte totale Cat D",
    penaltyLabelWriteOff_X: "Perte totale Cat X",
    penaltyPillAvoid: "Éviter",
    penaltyPillCaution: "Prudence",
    plainEnglishKickerAvoid: "VERDICT DU REGISTRE",
    plainEnglishKickerCaution: "VERDICT DU REGISTRE",
    simpleExplanationCardSubAvoid: "Touchez pour voir pourquoi le score a baissé",
    simpleExplanationCardSubCaution: "Touchez pour voir les conclusions du registre",
    realValueWorthifySub: "avec l'état actuel et les défauts",
    anchorFreeBadge: "Indépendant · sans ancrage",
    marketValueLabel: "Valeur de marché",
    worthifyValuationTitle: "Évaluation Worthify",
    worthifyExpertValuesThisCarAt: "Les experts Worthify valorisent cette voiture à",
    withCurrentStateAndDefects: "avec son état actuel et ses défauts",
    valuationGuidanceExplainer: "Idéalement, le prix demandé devrait être proche de ce chiffre. Nettement plus élevé = vous surpayez. Nettement plus bas = signal d'alerte : dégâts cachés, épave économique ou fraude. Posez des questions avant de payer.",
    negotiationGapExplainer: "Prix demandé {asking}, valeur réelle Worthify {realValue}. L'écart de {gap} reflète l'état actuel de la voiture et doit faire partie de votre négociation.",
    suspiciouslyCheapWarning: "{asking} pour une valeur réelle de {realValue} est anormalement bas. Une voiture ne se vend pas si peu sans raison — vérifiez les dégâts cachés, les documents manquants, un crédit en cours ou une épave économique avant de payer.",
    fairOrBelowExplainer: "{asking} pour une valeur réelle de {realValue} — c'est correct ou déjà sous la valeur Worthify. Pas de marge de négociation significative sur la valeur seule, mais vous pouvez toujours utiliser les coûts de réparation comme levier.",
    offTheAskingPrice: "de réduction sur le prix demandé",
    basedOnTheseIssues: "Sur la base de ces défauts confirmés",
    realisticRepairCost: "Coût de réparation réaliste",
    priceAboveMarket: "Prix demandé supérieur à la valeur du marché",
    overMarketValue: "au-dessus de la valeur marchande typique",
    negotiationExplainer: "Ce chiffre reflète le coût réel de la réparation de ce que le MOT révèle réellement — pas des scénarios catastrophes. Utilisez-le comme point de départ avec le vendeur.",
    useThisToLowerPrice: "Utilisez ceci pour baisser le prix",
    totalRepairCostRange: "Fourchette totale des coûts de réparation",
    whatToSayToSeller: "Quoi dire au vendeur",
    verdictAvoidCar: "ÉVITEZ CETTE VOITURE",
    verdictShortBad: "Très mauvaise valeur.",
    verdictShortMedium: "Prudence requise.",
    verdictShortGood: "Achat solide.",
    verdictSubShortBad: "Véhicule à haut risque.",
    verdictSubShortMedium: "Quelques problèmes détectés.",
    verdictSubShortGood: "Véhicule avec historique propre.",
    scoreCardSubtext: "Coûts de réparation \u00B7 Problèmes cachés \u00B7 Levier de négociation",
    potentialLossTitle: "Perte potentielle en achetant cette voiture",
    overpricedByLabel: "Surpayé de",
    totalPotentialLoss: "Perte potentielle totale",
    totalEstimatedCost: "Coût total estimé",
    detailedPotentialCosts: "Risques et coûts potentiels détaillés",
    bigCostHeadline: "Investissement futur attendu : {amount}",
    expectedCostTitle: "Coût de possession attendu (12–24 mois)",
    expectedCostTypicalSuffix: "typique",
    expectedCostRangeSuffix: "fourchette réaliste",
    expectedCostRelativePrefix: "≈",
    expectedCostRelativeSuffix: "de la valeur du véhicule",
    expectedCostDriversTitle: "Causes :",
    expectedCostWorstTitle: "Scénario du pire",
    expectedCostWorstBody: "Jusqu'à {amount}+ en cas de panne majeure ({worst_drivers}).",
    expectedCostFootnote: "Basé sur l'historique MOT, les faiblesses moteur connues et les statistiques de réparation.",
    expectedCostNoData: "Aucun facteur de coût marquant pour le moment — à surveiller au prochain entretien.",
    costSubtitleExplanation: "Coûts réalistes à prévoir sur 12-24 mois — basés sur les défauts confirmés, la famille du moteur et les faiblesses typiques de la plateforme.",
    paywallTeaserLow: "Sur le papier, ça tient la route. Le rapport complet montre ce qu'il faut vérifier avant de signer.",
    paywallTeaserMedium: "Nous avons trouvé des éléments à connaître avant de payer. Rapport complet pour £1.",
    paywallTeaserHigh: "Plusieurs risques en perspective. Voyez exactement ce qu'ils vont coûter avant le vendeur.",
    paywallTeaserScam: "Le prix paraît trop beau pour être vrai. Rapport complet — avant de virer un centime.",
    paywallTeaserCTA: "Débloquer le rapport complet — £1",
    expertSellerScriptNoHistory: "Bonjour — la voiture m'intéresse sérieusement. Worthify a réalisé une estimation indépendante basée sur la famille moteur, la fiabilité de la plateforme et l'état actuel — la valeur réaliste est de {realValue}. Pour rester équitable, il faudrait réduire le prix de {target}.",
    expertSellerScriptValuationOnly: "Bonjour — je souhaite finaliser cette semaine. L'estimation indépendante Worthify — moteur, plateforme et état — donne {realValue}. Je suis prêt à payer ce montant aujourd'hui.",
    whyScoreTitle: "Pourquoi ce score",
    whyScoreNoHistorySub: "Pas d'historique CT, le score repose principalement sur les données moteur et plateforme :",
    whyScoreWithHistorySub: "Facteurs déterminants :",
    whyScoreFactorEngine: "Risque famille moteur",
    whyScoreFactorPlatform: "Risque plateforme du modèle",
    whyScoreFactorHistory: "Profil historique CT",
    whyScoreFactorUsage: "Profil d'utilisation / kilométrage",
    whyScoreFactorSafety: "Note crash-test",
    whyScoreNoHistoryHint: "Les voitures neuves sans historique partent plus bas car nous ne voyons pas encore comment ce véhicule précis a été conduit et entretenu — seulement le comportement moyen du moteur et de la plateforme.",
    familyDeltaBetter: "Votre {make_model} obtient {pts} pts de plus que la moyenne {family} ({n} véhicules analysés).",
    familyDeltaWorse: "Votre {make_model} obtient {pts} pts de moins que la moyenne {family} ({n} véhicules analysés).",
    familyDeltaSame: "Votre {make_model} est exactement dans la moyenne de la famille {family} ({n} véhicules analysés).",
    socialProofTitle: "Tendance dans cette famille moteur",
    socialProofSubtitle: "Sur {n} {family} analysées :",
    socialProofIssueRow: "{pct}% ont eu {issue}",
    confidenceBadgeLabel: "Confiance",
    confidenceHigh: "ÉLEVÉE",
    confidenceMedium: "MOYENNE",
    confidenceLow: "FAIBLE",
    confidenceConsensus: "consensus de {n} IA",
    vinVerifiedLabel: "VIN vérifié",
    vinVerifiedSource: "décodage NHTSA",
    vinVerifiedTooltip: "Variante moteur, finition et usine identifiées à partir de votre VIN — analyse plus précise.",
    loadingFactPeers: "Comparaison avec {n} {family} déjà analysées",
    loadingFactPeersFew: "Construction du profil pour cette famille moteur — moins de 5 véhicules de référence",
    loadingFactMOT: "Lecture de {n} contrôles techniques pour ce véhicule",
    loadingFactMOTNew: "Voiture neuve — aucun contrôle technique enregistré",
    loadingFactAge: "{make} {model} ({year}) — récupération des points faibles typiques",
    loadingFactScoring: "Calcul du score Worthify — aucune IA ne décide seule",
    loadingFactSafety: "Récupération des résultats crash-test Euro NCAP",
    minimalRisk: "Risque minimal",
    scoreLabel: "Worthify Score",
    riskFactors: "Facteurs de risque",
    fullAnalysisInPdf: "Explication complète des risques, conseils de négociation & historique MOT dans le rapport PDF",
    pdfUpsellTitle: "Obtenir le rapport de risque complet",
    pdfIncludes1: "Estimations spécifiques des coûts de réparation",
    pdfIncludes2: "Levier de négociation (montants £)",
    pdfIncludes3: "Recommandation finale achat/éviter",
    pdfIncludes4: "Analyse détaillée des risques",
    pdfIncludes5: "Informations moteur et fiabilité",
    topResultCta: "Obtenir de l'aide",
    topResultSupportCopy: "Quel que soit le verdict — nous sommes avec vous. Vrais chiffres, vrais leviers, vraie protection.",
    unlockSectionHeadline: "Vous n'avez pas besoin d'être expert en voitures pour acheter une bonne voiture. Téléchargez le PDF avec des conseils et des données pour faire baisser le prix d'achat. Consultez l'analyse complète expliquée simplement. Ne vous faites pas avoir.",
    unlockSectionCta: "Débloquer 🔓 / Télécharger le PDF / Données avancées pour £1",
    resultVerdictLabel: "Verdict",
    riskOutlookLabel: "Niveau de risque",
    potentialLossLabel: "Perte potentielle",
    decisionMoodLabel: "Signal décisionnel",
    heroCaptionHigh: "Cette voiture pourrait coûter cher à entretenir.",
    heroCaptionMedium: "Réfléchissez à deux fois avant de dire oui.",
    heroCaptionLow: "Cette offre semble plus sûre que la plupart.",
    costAlertLabel: "Alerte coût",
    vehicleSnapshotLabel: "Aperçu du véhicule",
    priorityReviewLabel: "Risques prioritaires",
    unlockPremiumSection: "Débloquer la section premium",
    fullIssuesEyebrow: "Tous les problèmes",
    advancedDataLabel: "Données avancées",
    pdfUnlockLabel: "Déblocage PDF",
    
    // Scam Detection
    scamWarning: "ALERTE PRIX",
    scamAlertTitle: "Arnaque potentielle détectée",
    scamAlertDesc: "Ce prix est anormalement bas. Pourrait indiquer une fraude, un véhicule volé ou des dommages cachés.",
    scamRiskBadge: "RISQUE D'ARNAQUE ÉLEVÉ",
    suspiciousBadge: "PRIX SUSPECT",
    overpricedBadge: "SURÉVALUÉ",
    fairPriceBadge: "PRIX JUSTE",
    priceRange: "Fourchette du marché",
    priceComparison: "Prix vs valeur réelle",
    ofMarketValue: "de la valeur réelle",
    
    unlockFullReport: "DÉBLOQUER LE RAPPORT DE RISQUE COMPLET — SEULEMENT £1",
    verdictIncludesLine1: "Inclut problèmes cachés, dommages passés et analyse des risques",
    verdictIncludesLine2: "Pas de compte requis • Accès instantané",
    verdictClarityLine: "L'accès est valable pour cette session uniquement",
    verdictAvoidMistakes: "Évitez des erreurs coûteuses avant d'acheter",
    verdictTrustedBy: "Approuvé par les acheteurs de voitures au Royaume-Uni",
    verdictSecureLine: "Paiement sécurisé • Données réelles du véhicule • Résultats instantanés",
    whatYouUnlock: "Ce que vous débloquez",
    unlockItem1: "Risques d'accidents et dommages cachés",
    unlockItem2: "Détection de fraude kilométrique",
    unlockItem3: "Coûts de réparation exacts (£)",
    unlockItem4: "Levier de négociation — combien réduire le prix",
    unlockItem5: "Verdict final : ACHETER / NÉGOCIER / ÉVITER",
    limitedOffer: "Prix de lancement : £1",
    unlockCtaNew: "Débloquer le rapport détaillé pour £1 →",
    poweredByLine: "Accès unique • Données réelles • Analyse d'expert",
    verdictHighCostWarning: "Cela pourrait vous coûter plus que la voiture elle-même.",
    verdictBackLink: "← Retour",
    paymentProcessing: "Traitement du paiement...",
    checkingPayment: "Vérification du statut du paiement...",
    paymentConfirmedTitle: "Paiement confirmé !",
    paymentConfirmedSub: "Préparation de votre rapport…",
    paymentVerifyTitle: "Vérification du statut du paiement…",
    paymentVerifySub: "Nous confirmons votre paiement auprès de Stripe — cela ne prend généralement que quelques secondes. Ne fermez pas cette fenêtre.",
    paymentVerifySecure: "Paiement sécurisé par Stripe",
    pdfDownloadedToast: "✓ Rapport téléchargé",
    paymentVerifyingBanner: "Nous vérifions votre paiement. Le PDF sera téléchargé automatiquement dès que le paiement sera confirmé.",
    trustText: "Sans inscription • Données réelles DVSA + DVLA • 🛡 More Than HPI Check • Verdict instantané",
    aiSummaryTitle: "Résumé expert",
    aiAnalysisTitle: "Analyse d'expert",
    riskExplanation: "Explication du risque",
    positivesTitle: "Signaux positifs",
    negotiationInsight: "Conseil de négociation",
    finalAdvice: "Conseil final",
    topRiskTitle: "Risque principal",
    otherRisksTitle: "Autres risques potentiels",
    otherRisksSubtitle: "Faiblesses typiques de ce moteur / plateforme — non confirmées sur cette voiture.",
    repairCost: "Cout de reparation",
    knownModelIssuesTitle: "Problemes connus du modele",
    aiEstimatedValue: "Valeur estimee",
    priceEvalTitle: "Evaluation du prix",
    evidenceTitle: "Preuves du MOT",
    expertNoteLabel: "Note d'expert",
    topIssueLabel: "Problème principal sur cette voiture",
    topIssueLead: "Ce défaut est enregistré dans l'historique MOT de ce véhicule.",
    topIssueLeadRecurring: "Ce défaut est apparu dans {count} contrôles MOT et reste consigné — il n'a pas été résolu et va très probablement s'aggraver.",
    notConfirmedBadge: "Non confirmé sur cette voiture",
    engineFamilyContext: "Contexte moteur / plateforme",
    consequencesTitle: "Si ignore",
    severityHigh: "RISQUE ELEVE",
    severityMedium: "RISQUE MOYEN",
    severityLow: "RISQUE FAIBLE",
    engineAnalysisTitle: "Analyse du moteur",
    engineIdentified: "Moteur identifie",
    engineCode: "Code moteur",
    engineKnownIssues: "Problemes moteur connus",
    typicalWeaknessesTitle: "Faiblesses typiques de ce moteur",
    typicalWeaknessesDisclaimer: "Ce sont des problèmes potentiels connus pour CETTE famille de moteurs — ils peuvent arriver, mais pas forcément. Les vrais défauts confirmés de votre voiture figurent dans l'historique MOT ci-dessous.",
    safetyRatingLabel: "Sécurité (crash test)",
    safetyVerdictSafe: "Haute sécurité — prouvée lors des crash tests",
    safetyVerdictAverage: "Sécurité moyenne — correcte mais sans plus",
    safetyVerdictPoor: "Sécurité en dessous de la moyenne — envisagez d'autres options",
    safetyRatingSource: "Test indépendant Euro NCAP",
    engineConfidence: "Confiance",
    mileageAnalysisTitle: "Analyse du kilometrage",
    averageYearly: "Moyenne annuelle",
    milesPerYear: "miles/an",
    mileageTrend: "Tendance",
    trendStable: "Stable",
    trendHigh: "Utilisation elevee",
    trendLow: "Faible utilisation",
    trendInconsistent: "Incoherent",
    trendRollback: "Retour au compteur",
    trendUnknown: "Inconnu",
    mileageFlags: "Alertes",
    flagRollback: "Retour au compteur suspecte",
    flagLowUsage: "Utilisation tres faible",
    flagHighUsage: "Kilometrage annuel eleve",
    flagInconsistent: "Incoherence du kilometrage",
    aiMileageInsight: "Analyse experte du kilométrage",
    vehicleInfo: "Informations sur le véhicule",
    mileageLabel: "Kilometrage",
    mileageVsAge: "miles/an moyenne pour age du vehicule",
    registration: "Immatriculation",
    makeModel: "Marque & Modèle",
    year: "Année",
    engine: "Moteur",
    engineCode: "Code moteur",
    
    // Statistics
    totalTests: "Tests totaux",
    failedTests: "Tests échoués",
    failsInLast3: "Échecs dans les 3 derniers",
    dangerousDefects: "Défauts dangereux",
    recurringIssues: "Problèmes récurrents",
    
    // Analysis sections
    aiExpertAnalysis: "Analyse experte",
    priceAnalysis: "Analyse des prix",
    marketMedian: "Médiane du marché",
    typicalRange: "Plage typique",
    priceFlag: "Indicateur de prix",
    knownIssues: "Problèmes connus pour ce modèle",
    anomaliesDetected: "Anomalies détectées",
    recurringIssuesTitle: "Problèmes récurrents",
    motTestHistory: "Historique des tests MOT",
    detectedIssuesTitle: "Problèmes détectés",
    fullIssuesTitle: "Problèmes",
    
    // Defect types
    advisory: "Conseil",
    major: "Majeur",
    dangerous: "Dangereux",
    recurring: "Récurrent",
    
    // MOT Timeline
    noDefectsFound: "✓ Aucun défaut trouvé - test propre",
    miles: "miles",
    expires: "Expire",
    appears: "Apparaît",
    times: "fois",
    
    // Anomaly descriptions
    mileageDrop: "Lecture du compteur diminuée entre les tests - manipulation potentielle",
    coolingSystemFlags: "Problèmes de système de refroidissement détectés dans l'historique MOT",
    chainIssueSuspected: "Problèmes potentiels de chaîne de distribution (fréquents sur ce moteur)",
    
    // Sources
    sources: "Sources",
    link: "Lien",

    // Loading overlay
    analyzingTitle: "Analyse de l'historique du véhicule...",
    loadingStep1: "Vérification de l'historique MOT...",
    loadingStep2: "Détection des problèmes cachés...",
    loadingStep3: "Analyse des tendances kilométriques...",
    loadingStep4: "Identification des risques moteur...",
    loadingStep5: "Estimation des coûts de réparation...",
    loadingStep6: "Vérification des anomalies...",
    loadingIssuesDetected: "Problèmes potentiels détectés...",
    loadingFinalizing: "Finalisation de l'évaluation des risques...",
    aiWorking: "Experts examinent...",
    aiDispatch: "Rassemblement des experts...",
    aiRoleEngine: "Expert moteur",
    aiRolePlatform: "Expert plateforme",
    aiRoleRisk: "Expert risques",
    expertConfirmBadge: "Validé par 3 experts",
    expertConfirmTitle: "Équipe d'experts confirmée",
    expertConfirmSubtitle: "3 experts indépendants ont examiné votre rapport complet",
    expertConfirmFinalScore: "Score final",
    premiumExpertOverlayBadge: "Analyse premium terminée",
    premiumExpertOverlayTitle: "Les experts ont examiné les données complètes",
    premiumExpertOverlaySub: "Mise à jour de votre Worthify Score à partir des registres…",
    premiumExpertOverlayScore: "Score mis à jour",
    premiumExpertOverlayDone: "Touchez n'importe où pour voir le rapport",
    premiumExpertAnnaRisk: "Anna · Experte risque",
    premiumExpertEngine: "Marcus · Expert moteur",
    premiumExpertPlatform: "Iris · Experte plateforme",
    premiumFindingWriteOff: "a trouvé une perte totale enregistrée",
    premiumFindingTheft: "a trouvé un signalement de vol",
    premiumFindingMileage: "a détecté une anomalie de kilométrage",
    premiumFindingFinance: "a trouvé un financement en cours",
    expertConfirmVerdictRefined: "Verdict affiné par le consensus complet des experts",
    // Auto-generated translations (Worthify i18n batch)
    abiGroupLabel: "Groupe ABI",
    accessFullAssessment: "Accéder à l'évaluation complète des risques",
    accidentCheck1: "Défauts de châssis / structure dans l'historique MOT",
    accidentCheck2: "Défaillances d'alignement direction & suspension",
    accidentCheck3: "Notes de réparation carrosserie majeure entre centres de contrôle",
    accidentCheck4: "Recoupé avec les registres d'accidents du secteur",
    accidentChecksTitle: "Ce que nous avons vérifié",
    accidentModalTitle: "Historique d'accidents",
    accidentRiskHigh: "Historique de dommages potentiel",
    accidentRiskLow: "Aucun signalement d'accident",
    accidentScopeLabel: "Basé sur les contrôles structurels MOT",
    addVinBadge: "Mise à niveau gratuite",
    addVinBadgeLowConf: "Améliorer la précision",
    addVinChecking: "Vérification du VIN…",
    addVinCopy: "Détectez les voitures clonées et les arnaques par substitution de VIN en quelques secondes. Nous comparons votre VIN avec la marque et l'année DVLA — instantané, gratuit, sans paiement supplémentaire.",
    addVinCopyLowConf: "Il s'agit d'un modèle récent / de niche — les données de prix publiques sont limitées. L'ajout du VIN nous permet d'identifier la finition exacte, le prix catalogue de l'année-modèle et la vraie valeur résiduelle.",
    addVinCta: "Ajouter le VIN maintenant",
    addVinDone: "Terminé",
    addVinError: "Échec de la vérification du VIN. Veuillez réessayer.",
    addVinModalCopy: "Saisissez le VIN à 17 caractères du vendeur (certificat V5C ou plaque de pare-brise). Nous le vérifierons par rapport à la marque et l'année DVLA — s'il ne correspond pas, votre score sera forcé à ÉVITER.",
    addVinModalTitle: "Vérifier le VIN",
    addVinOkCopy: "Aucun signal de clonage. Votre tableau de bord affiche désormais le badge vérifié.",
    addVinOkTitle: "VIN vérifié — marque et année correspondent",
    addVinScamCopy: "Le score a été forcé à ÉVITER. Consultez la bannière rouge sur votre tableau de bord.",
    addVinScamTitle: "Incohérence VIN détectée — voiture possiblement clonée",
    addVinSubmit: "Vérifier le VIN maintenant",
    addVinTitle: "Vérifier que le VIN correspond à l'immatriculation",
    addVinTitleLowConf: "Ajouter le VIN pour une valorisation plus précise",
    addVinUndecodableCopy: "La base de données publique américaine ne répertorie pas ce VIN. Courant pour les modèles uniquement britanniques — pas un signal d'alerte en soi.",
    addVinUndecodableTitle: "VIN enregistré — décodage public impossible",
    aiSuggested: "Suggéré par IA",
    allClear: "Tout est clair",
    allDetectedIssues: "Tous les problèmes détectés",
    analyzingReassurance: "L'analyse se termine généralement en 30 à 60 secondes",
    annualCostLabel: "Total annuel",
    anomaliesShort: "Anomalies",
    assumedMiles: "présumé 10k mi/an",
    averageSoldLabel: "Prix vendu moy.",
    averageYearlyMileage: "Kilométrage annuel moyen",
    avgDaysLabel: "Jours moy. avant vente",
    avgDaysOnMarket: "jours moy. sur le marché",
    avgYearlyMiles: "Miles moy. / an",
    basedOn30yoLabel: "Conducteur de 30 ans, 5 ans sans sinistre",
    basedOnLastNSales: "Basé sur les 5 dernières ventes comparables",
    benefitAccident: "Vérification accident & véhicule épave",
    benefitDepreciation: "Prévision de dépréciation",
    benefitEngine: "Analyse moteur & problèmes connus",
    benefitFinance: "Vérification crédit en cours",
    benefitNegotiation: "Tactiques de pouvoir de négociation",
    benefitPdf: "Rapport PDF imprimable complet",
    benefitSimilar: "Voitures similaires vendues (5 dernières)",
    benefitUlez: "ULEZ + coûts d'utilisation sur 5 ans",
    betaDataBannerBody: "Ce module utilise actuellement des estimations heuristiques basées sur le profil du véhicule. L'intégration de données réelles arrive dans la prochaine version.",
    betaDataBannerTitle: "Données bêta — version complète à venir",
    brakesLabel: "Freins",
    cancelLabel: "Annuler",
    checkNewCarCta: "Vérifier une nouvelle voiture",
    checkNewCarForOnePound: "Vérifier une nouvelle voiture pour £1.00",
    close: "Fermer",
    co2Label: "CO₂",
    confidenceLabelHigh: "Confiance élevée",
    confidenceLabelLow: "Confiance faible",
    confidenceLabelMedium: "Confiance moyenne",
    copyNegoError: "Échec de la copie — réessayez",
    copyNegoRangeLabel: "Fourchette",
    copyNegoSourceLabel: "Source",
    copyNegoSuccess: "Arguments copiés — collez dans WhatsApp ou SMS",
    copyNegoTitle: "Worthify – arguments de négociation",
    copyNegoTotalLabel: "Objectif total",
    copyNegotiationAria: "Copier les arguments de négociation dans le presse-papiers",
    copyNegotiationCta: "Copier les arguments de négociation",
    copyPasteReadyLabel: "Copier · coller · envoyer",
    costBreakdownTitle: "Détail",
    costDriversTitle: "Ce qui génère ces coûts",
    costFuel: "Carburant",
    costInsurance: "Assurance",
    costService: "Entretien",
    costSubtitleShort: "Coûts réalistes à prévoir pour les 12–24 prochains mois.",
    costTax: "Taxe de circulation",
    costTierClean: "Semble propre",
    costTierHigh: "Élevé",
    costTierLow: "Faible",
    costTierModerate: "Modéré",
    currentRegLabel: "Actuelle",
    currentValueLabel: "Valeur actuelle",
    damageHistoryLabel: "Historique des dommages",
    dangerousDefectsFound: "défauts dangereux détectés",
    dangerousDefectsHeadline: "Vous avez des défauts dangereux",
    dashboardAiDisclaimer: "Ceci n'est pas une inspection mécanique. Effectuez toujours votre propre contrôle mécanique avant d'acheter.",
    dataSourceDvla: "Source : DVLA VES",
    dataSourcesCopy: "DVLA, MOT, assurance, données de marché et plus",
    dataSourcesTitle: "Nous vérifions plus de 50 sources de données",
    daysToSell: "jours pour vendre",
    defectRecurringSuffix: "Récurrent au MOT — non réparé, peut empirer avec le temps.",
    defectThemeBrakes: "Usure des composants de freinage",
    defectThemeCorrosion: "Corrosion / usure structurelle",
    defectThemeElectrical: "Problème électrique / de charge",
    defectThemeEmissions: "Problème du système d'émissions",
    defectThemeExhaust: "Usure du système d'échappement",
    defectThemeLights: "Défaut d'éclairage",
    defectThemeOilLeak: "Fuite d'huile moteur / suintement de joint",
    defectThemeScreen: "Pare-brise / vitrage",
    defectThemeSeatbelt: "Contrôle ceinture / dispositif de retenue",
    defectThemeSteering: "Usure des joints de direction / suspension",
    defectThemeSuspension: "Usure des composants de suspension",
    defectThemeTyres: "Usure / état des pneus",
    defectThemeWipers: "Essuie-glaces / lave-glaces",
    depreciationModalTitle: "Prévision de dépréciation",
    detectedTimesPrefix: "Détecté",
    detectedTimesSuffix: "fois dans l'historique MOT",
    downloadingPdf: "Téléchargement…",
    dvlaRecordLabel: "Dossier DVLA",
    engineAnalysisShort: "Problèmes moteur",
    engineCodeLabel: "Code moteur",
    errorRateLimit: "Vous avez effectué trop de vérifications en peu de temps. Veuillez patienter quelques minutes et réessayer.",
    errorRateLimitPayment: "Trop de tentatives de paiement. Veuillez patienter quelques minutes et réessayer.",
    estimatedCost: "Coût estimé",
    euroClassLabel: "Classe Euro",
    expectedCostBottomCaption: "Coût estimé pour les 12–24 prochains mois",
    expectedCostFallbackDrivers: "L'exposition typique sur 12–24 mois pour cette voiture est d'environ £{cost}, principalement due à {drivers}.",
    expectedCostFallbackGeneric: "L'exposition typique sur 12 à 24 mois pour cette voiture est d'environ £{cost} selon son âge, son kilométrage et les problèmes connus du modèle.",
    expectedCostFallbackRange: "Fourchette réaliste £{lo}–£{hi} ; un entretien préventif maintenant vous maintient généralement près de la limite inférieure.",
    expectedCostFallbackTopRisk: "L'exposition typique sur 12 à 24 mois pour cette voiture est d'environ £{cost}, avec {issue} comme principale préoccupation.",
    expectedCostHeroTitle: "Coût\\nfutur attendu",
    expectedCostInsight: "Les coûts sont modérés, mais les problèmes récurrents augmentent le risque de factures de réparation plus élevées.",
    expectedCostModalTitle: "Coût futur attendu",
    expectedCostShortLabel: "Coût attendu",
    expectedCostShortTitle: "Investissement futur attendu",
    expectedCostSubtitle: "Coût estimé sur les 12 à 24 prochains mois",
    expertDeepAnalysisTitle: "Conclusions de chaque expert",
    expertInsightLabel: "Analyse d'expert",
    expertLeverageTitle: "Levier d'expert",
    expertNoFindings: "Aucun point spécifique signalé par cet expert.",
    expertSummaryLabel: "Résumé",
    expertTipBody: "Faites-la inspecter avant l'achat et budgétez la réparation.",
    expertTipLabel: "Conseil d'expert",
    expertVerifiedBadge: "Vérifié",
    expertViewLabel: "Avis d'expert",
    expertiseLockedMore: "plus dans Premium",
    expertiseModalTitle: "Analyse d'expert",
    expertiseUnlockCta: "Débloquer premium",
    expertsCountBadge: "3 experts",
    failedMotsLabel: "MOT échoués",
    failedMotsTitle: "Tests MOT échoués",
    failedOnce: "test échoué",
    failedPlural: "tests échoués",
    failedTestDetails: "Détails du test échoué",
    financeClean: "Aucun financement en cours",
    financeCleanCopy: "Aucun prêt actif, leasing ou accord HP détecté sur ce véhicule. Vous pouvez procéder en toute sécurité.",
    financeContextCopy: "Pour une valorisation autour de {value}, les voitures avec financement en cours sont impliquées dans ~5 % des litiges de vente privée au Royaume-Uni. Ce véhicule est libre.",
    financeContextTitle: "Contexte",
    financeFound: "Financement en cours",
    financeFoundCopy: "Ce véhicule a un financement actif — il ne peut pas être légalement vendu avant règlement. Refusez jusqu'à ce que le vendeur fournisse une preuve de règlement.",
    financeModalTitle: "Financement en cours",
    financeStatusLabel: "Statut du financement",
    flaggedAnomalies: "Anomalies signalées",
    forecastTableTitle: "Prévision",
    fromCountryLabel: "Pays",
    fullPdfReport: "Rapport PDF complet",
    fullTimeline: "Chronologie complète",
    govUkDisclaimer: "Estimé selon l'année et le carburant. Vérifiez sur gov.uk/check-clean-air-zone-charge",
    helpDownloadHero: "Téléchargez votre rapport complet",
    helpDownloadSub: "Analyses Premium + PDF — déjà payé",
    helpHeroKicker: "3 experts indépendants",
    helpHeroTitle: "Évaluation de l'historique de ce véhicule pour vous",
    helpModalTitle: "Comment fonctionne Worthify",
    helpSection1Copy: "La carte principale affiche le verdict basé sur 3 experts indépendants évaluant l'historique de ce véhicule.",
    helpSection1Title: "Votre verdict",
    helpSection2Copy: "Appuyez sur n'importe quelle tuile pour ouvrir la fenêtre complète avec détails, graphiques et conseils d'experts. Glissez gauche/droite pour passer d'une fenêtre à l'autre.",
    helpSection2Title: "Explorez chaque tuile",
    helpSection3Copy: "Un paiement unique de £4,99 débloque l'analyse moteur, le pouvoir de négociation, la vérification des anomalies, le risque de financement caché et le rapport PDF imprimable complet.",
    helpSection3Title: "Débloquez tout",
    helpUnlockHero: "Débloquez l'image complète",
    helpUnlockSub: "Moteur · Négociation · Anomalies · Financement · PDF",
    heroFailedLabel: "ÉCHOUÉ",
    heroHpiBadgeAria: "En savoir plus sur More Than HPI Check",
    heroHpiBadgeText: "More Than HPI Check",
    heroMotPlural: "MOTS",
    heroMotSingular: "MOT",
    highRiskLabel: "RISQUE ÉLEVÉ",
    hpiIncludedAi: "Analyses d'achat basées sur l'IA",
    hpiIncludedFinance: "Vérifications de crédit en cours",
    hpiIncludedIdentity: "Vérification de l'identité du véhicule",
    hpiIncludedImport: "Statut d'importation / exportation",
    hpiIncludedMarket: "Évaluation du marché",
    hpiIncludedMileage: "Détection d'anomalies kilométriques",
    hpiIncludedMot: "Analyse de l'historique MOT",
    hpiIncludedPdf: "Export du rapport PDF",
    hpiIncludedPlate: "Historique des changements de plaque",
    hpiIncludedRisk: "Évaluation du risque du véhicule",
    hpiIncludedShare: "Partager avec un mécanicien",
    hpiIncludedStolen: "Vérifications de vol",
    hpiIncludedVin: "Vérification VIN",
    hpiIncludedWorthifyValue: "Analyse Worthify Value",
    hpiIncludedWriteOff: "Épave assurance (A, B, S, N)",
    ifIgnoredTitle: "Si ignoré, cela peut mener à :",
    importDetected: "Importation détectée",
    importImpactCopy: "Les voitures importées peuvent être plus difficiles à assurer et avoir des délais de livraison de pièces plus lents. Vérifiez le V5C pour la date d'immatriculation UK et tout certificat NOVA (Notification of Vehicle Arrival).",
    importImpactTitle: "Ce que cela signifie",
    importModalTitle: "Historique d'importation",
    importTypeLabel: "Type d'importation",
    inLabel: "En",
    includedTitle: "Tout ce qui est inclus",
    independentBadge: "Indépendant",
    insuranceDisclaimer: "Groupe estimé. Votre prime réelle dépend de l'âge, du code postal, de l'historique des sinistres et de la franchise.",
    insuranceGroupModalTitle: "Groupe d'assurance",
    issuesFound: "problèmes détectés",
    knownIssuesTitle: "Problèmes moteur connus",
    lastChangeLabel: "Dernier changement",
    legalAllRights: "Tous droits réservés.",
    legalBackToHome: "Retour à Worthify",
    legalLastUpdated: "Dernière mise à jour",
    legalNavCookies: "Politique des cookies",
    legalNavAccessibility: "Accessibilité",
    legalNavPrivacy: "Politique de confidentialité",
    legalNavTerms: "Conditions d'utilisation",
    leverageLabel: "Levier",
    lifeRemaining: "durée de vie restante",
    lockedPremiumCopy: "Débloquez cette section avec le rapport PDF complet et 14 autres vérifications premium pour £4.99.",
    lockedPremiumTitle: "Analyse premium",
    looksLike: "Ressemble à",
    looksLikeA: "Ressemble à un",
    lowRiskLabel: "RISQUE FAIBLE",
    marketGaugeAskingLabel: "Demandé",
    marketGaugeMarketLabel: "Marché",
    marketGaugeVsMarket: "vs marché",
    marketGauge_FAIR: "Juste prix",
    marketGauge_SIGNIFICANTLY_OVER: "Nettement surévalué",
    marketGauge_SLIGHTLY_OVER: "Légèrement surévalué",
    marketGauge_UNDERPRICED: "Sous-évalué",
    maybeLaterCta: "Peut-être plus tard",
    mediumRiskLabel: "MOYEN",
    methodologyConfHighHint: "Historique MOT, VIN et kilométrage présents — consensus multi-IA sur les résultats.",
    methodologyConfLowHint: "Données publiques limitées pour ce véhicule. Le score est heuristique — inspection physique fortement recommandée.",
    methodologyConfMedHint: "Certains points de données manquants (ex. VIN ou MOT complet). Le score est fiable mais pas maximal.",
    methodologyConfidence: "Confiance : {level}",
    methodologyDisclaimer: "Worthify agrège les données officielles DVSA, DVLA et NHTSA avec un moteur de consensus à 3 IA — un vrai More Than HPI Check à une fraction du prix. Il ne remplace pas une inspection physique. Réservez toujours votre propre contrôle mécanique avant d'acheter.",
    methodologyDisclaimerTitle: "Inspection indépendante toujours recommandée",
    methodologyIntro: "Worthify combine les données publiques du gouvernement britannique avec un consensus IA à 3 modèles pour estimer le risque d'achat d'une voiture d'occasion spécifique. Voici exactement d'où provient chaque information.",
    methodologySourcesTitle: "Sources de données",
    methodologyTitle: "Comment fonctionne Worthify",
    mileageAnomalyBadge: "ANOMALIE",
    mileageAnomalyCopy: "Anomalie de kilométrage détectée",
    mileageConsistent: "Le kilométrage semble cohérent",
    mileageHeroTitle: "Analyse\\ndu kilométrage",
    mileageInsightAnomaly: "La progression du kilométrage présente des incohérences. Examinez attentivement les registres d'entretien.",
    mileageInsightConsistent: "Le kilométrage semble cohérent avec l'âge et l'historique du véhicule.",
    mileageInsightTitle: "Aperçu du kilométrage",
    mileageStableBadge: "STABLE",
    monthlyCostLabel: "Par mois",
    moreHpiEveryoneBody: "Conçu pour les acheteurs de voitures ordinaires, les jeunes conducteurs, les familles, les passionnés et les automobilistes expérimentés. Que vous soyez mécanicien ou achetiez votre première voiture, Worthify vous aide à comprendre ce que signifient réellement les données avant de dépenser votre argent.",
    moreHpiEveryoneTitle: "Conçu pour tous",
    moreHpiFooterChips: "🛡 More Than HPI Check · Analyse IA · Évaluation de marché · Analyses premium",
    moreHpiFooterTagline: "Intelligence véhicule, pas seulement historique véhicule.",
    moreHpiFooterTrust: "Propulsé par des sources fiables d'intelligence véhicule britannique et de données officielles.",
    moreHpiHeaderSub: "La plateforme d'intelligence véhicule la plus avancée du Royaume-Uni, conçue pour vous aider à prendre la bonne décision avant d'acheter.",
    moreHpiHeaderTitle: "Pourquoi Worthify est différent",
    moreHpiHeroBody: "Nous combinons des données britanniques fiables, une évaluation de marché et une analyse IA pour vous fournir des réponses claires, des explications simples et une vraie confiance.",
    moreHpiHeroHighlight: "More Than HPI Check",
    moreHpiHeroPost: ".",
    moreHpiHeroPre: "Worthify est ",
    moreHpiIncludedTitle: "Intelligence véhicule premium incluse",
    moreHpiIntroBody: "More Than HPI Check — Worthify combine intelligence véhicule britannique fiable, évaluation de marché et analyse IA dans un rapport facile à comprendre.",
    moreHpiIntroLead: "Worthify ne se contente pas d'afficher les données véhicule — il les explique.",
    moreHpiModalSubtitle: "La plateforme d'intelligence véhicule au meilleur rapport qualité-prix du Royaume-Uni",
    moreHpiModalTitle: "Pourquoi Worthify est-il différent ?",
    moreHpiMultilingualBody: "Les rapports et explications véhicule sont disponibles en plusieurs langues, rendant les contrôles véhicule plus accessibles pour tous au Royaume-Uni.",
    moreHpiMultilingualTitle: "Support multilingue",
    moreHpiNoKnowBody: "Worthify traduit les données véhicule complexes en explications simples que tout le monde peut comprendre. Comprenez ce que signifient les données avant de dépenser votre argent.",
    moreHpiNoKnowTitle: "Aucune connaissance automobile requise",
    moreHpiSourcesLine: "Nous utilisons des sources de données britanniques fiables, notamment DVLA, DVSA et les principaux fournisseurs de données véhicule.",
    moreHpiValueBody: "Worthify fournit une intelligence véhicule avancée, une évaluation de marché, une analyse MOT et des recommandations d'achat IA pour seulement ",
    moreHpiValueBodyEnd: ".",
    moreHpiValueKicker: "Pourquoi payer £30+ ?",
    moreHpiWhy30Body: "Worthify combine intelligence véhicule avancée, évaluation de marché et analyse IA dans un seul rapport abordable. Pas de jargon. Juste des réponses claires en qui vous pouvez avoir confiance.",
    moreHpiWhy30Title: "Pourquoi payer £30+ pour un rapport véhicule traditionnel ?",
    moreLockedHeadline: "3 analyses premium verrouillées",
    motConfirmedBadge: "Confirmé par MOT",
    motExpiryLabel: "Expiration du MOT",
    motHistoryLabel: "Historique MOT",
    motHistoryTitle: "Historique MOT",
    navExpertise: "Expertise",
    navMore: "Plus",
    navOverview: "Aperçu",
    navPremium: "Premium",
    navReports: "Rapports",
    navSearch: "Nouvelle recherche",
    navVehicle: "Véhicule",
    negoAskingLabel: "Demandé",
    negoBulletComfortPrice: "Une offre confortable reflétant ce risque se situe près de £{price}.",
    negoBulletKnownIssues: "Ce modèle a {n} points faibles documentés — soulevez-les lors de la visite.",
    negoBulletTopRisk: "Risque principal : {issue} — réparation typiquement £{lo}–£{hi}.",
    negoBulletTotalExposure: "Exposition totale aux réparations : £{lo}–£{hi} sur les 24 prochains mois.",
    negoEmptyCopy: "Aucun point de levier détecté — le profil technique et de marché de cette voiture semble propre. Une offre ferme mais équitable au prix demandé (ou 2–3% en dessous) est raisonnable.",
    negoFairWithRepairsLabel: "Juste avec réparations",
    negoMarketValueLabel: "Valeur de marché",
    negoScamBullet1: "Vérifiez l'identité du vendeur en personne avant tout paiement",
    negoScamBullet2: "Effectuez un contrôle DVLA / historique complet sur le VIN avant tout transfert de fonds",
    negoScamBullet3: "Refusez toute demande de crypto / carte cadeau / virement bancaire",
    negoScamCopy: "Le prix demandé (£{asking}) est bien inférieur à la vraie valeur de marché de cette voiture (£{value}). Ce schéma signale presque toujours une annonce frauduleuse, un véhicule volé, des dommages non divulgués ou une arnaque à l'entiercement. Ne payez aucun acompte, ne partagez pas de documents et n'organisez pas de transport. Signalez l'annonce et passez à autre chose.",
    negoScamHeader: "Arnaque détectée",
    negoScamTitle: "Ne négociez pas — partez immédiatement",
    negoScamVinCopy: "Le VIN du vendeur correspond à {vinMake} {vinYear}, mais l'immatriculation DVLA indique {dvlaMake} {dvlaYear}. C'est un signal classique de voiture clonée / échange de VIN. Ne versez aucun acompte et ne partagez aucun document.",
    negoScamVinTitle: "Le VIN ne correspond pas à l'immatriculation — partez immédiatement",
    negoSuspiciousAsk1: "Pourquoi le prix est-il inférieur au marché ? (perte d'emploi / vente urgente / problème caché ?)",
    negoSuspiciousAsk2: "Demandez un rapport d'historique complet + le V5C + l'historique complet d'entretien avant tout acompte",
    negoSuspiciousAsk3: "Inspectez en personne — ne payez jamais par crypto / virement / carte cadeau",
    negoSuspiciousCopy: "Le prix demandé de £{asking} est déjà £{gap} en dessous de la valeur marché de cette voiture (£{market}). Même après les £{rLo}–£{rHi} de réparations probables, un prix juste se situe autour de £{fair}. Le vendeur l'offre pour moins. Découvrez pourquoi avant de payer quoi que ce soit.",
    negoSuspiciousKicker: "Prix déjà inférieur au marché",
    negoSuspiciousTitle: "Ne négociez pas à la baisse — vérifiez d'abord",
    negotiationCumulativeLabel: "Économie cumulative acheteur",
    negotiationHeadline: "Objectif de négociation",
    negotiationItemTarget: "Offre suggérée",
    negotiationShort: "Levier",
    newSearchCopy: "Démarrez une nouvelle analyse pour une autre immatriculation. L'analyse actuelle reste sauvegardée.",
    newSearchPaymentCopy: "Chaque vérification de véhicule est un paiement unique de £1 qui déverrouille toutes les analyses premium pour cette voiture.",
    newSearchPaymentTitle: "Nouvelle analyse nécessite nouveau paiement",
    newSearchTitle: "Nouveau contrôle de voiture",
    noAnomalies: "Aucune anomalie détectée dans l'historique MOT.",
    noFailedDetails: "Données détaillées des défaillances non disponibles pour ce véhicule.",
    noImportFlag: "Marché UK / UE",
    noMajorRisks: "Aucun risque majeur",
    noMotDetails: "Chronologie MOT détaillée non disponible.",
    noPriceEvalCopy: "Ajoutez un prix cible pour obtenir une vérification du prix.",
    noRecurring: "Aucun problème récurrent trouvé dans l'historique MOT.",
    noVinForImport: "Ajoutez un VIN sur la page d'accueil pour un contrôle complet du pays d'origine.",
    nowLabel: "Maintenant",
    offAskingLabel: "sur le prix demandé",
    originLabel: "Origine",
    ourVerdictLabel: "Notre verdict",
    outOfLabel: "sur",
    ownerLabel: "Propriétaire",
    ownerPlural: "propriétaires enregistrés",
    ownerSingular: "propriétaire enregistré",
    ownersAverageCopy: "Propriété moyenne — aucun signal d'alerte, mais demandez les carnets d'entretien.",
    ownersCountLabel: "Total propriétaires",
    ownersFewCopy: "Peu de propriétaires — signifie généralement que la voiture a été bien entretenue.",
    ownersInsightTitle: "Aperçu de la propriété",
    ownersManyCopy: "Beaucoup de propriétaires en peu de temps peut signaler des problèmes — enquêtez attentivement.",
    ownersModalTitle: "Propriétaires précédents",
    ownersTimelineTitle: "Chronologie de propriété",
    ownersV5CFreshNote: "Émis au cours des 12 derniers mois — indique généralement un changement récent de propriété (DVLA).",
    ownersV5CLabel: "Dernier V5C émis",
    ownersV5COldNote: "Même document V5C toujours actif — aucun transfert enregistré récent.",
    paymentCancelledBody: "Aucun débit n'a été effectué. Vous pouvez réessayer quand vous le souhaitez.",
    paymentCancelledTitle: "Paiement annulé",
    paymentTimeoutError: "Le paiement prend plus de temps que prévu. Si vous avez été débité, veuillez contacter support@worthify.co.uk en mentionnant l'ID de session : ",
    pdfDownloadCopy: "Votre rapport PDF complet est prêt.",
    pdfDownloadNow: "Télécharger le rapport complet",
    pdfDownloadTitle: "Téléchargez votre rapport complet",
    pdfFullReportLabel: "Rapport complet",
    pdfIncludesTitle: "Contenu inclus",
    pdfReportLabel: "Rapport PDF complet",
    pdfReportValue: "Télécharger",
    pdfUnlockCopy: "Obtenez l'analyse complète, les avis d'experts et l'analyse des coûts en PDF.",
    pdfUnlockCta: "Déverrouiller pour £4.99",
    pdfUnlockTitle: "Déverrouillez le rapport complet",
    pdfUnlockedLabel: "Déverrouillé",
    perMonth: "par mois",
    perYear: "par an",
    perYearLabel: "par an",
    policeRegisterLabel: "Registre de police",
    preCheckoutBadge: "Confirmer l'achat",
    preCheckoutBenefitMot: "Analyse des risques MOT",
    preCheckoutBenefitRecall: "Vérification rappel + épave",
    preCheckoutBenefitShare: "PDF + partage avec mécanicien",
    preCheckoutBenefitValuation: "Estimation de marché",
    preCheckoutConsent: "J'accepte la livraison instantanée et comprends que je perds mon droit de rétractation de 14 jours.",
    preCheckoutNoSub: "Pas d'abonnement · Pas de renouvellement automatique",
    preCheckoutOneTime: "Paiement unique",
    preCheckoutPayCta: "Payer £{n} avec Stripe",
    preCheckoutPdfProductName: "Rapport Worthify Premium (PDF + 15 modules)",
    preCheckoutRedirecting: "Redirection vers Stripe…",
    preCheckoutTickToContinue: "Cochez la case pour continuer",
    preCheckoutTotal: "Total",
    preCheckoutTrustLine: "Sécurisé par Stripe · Vos données bancaires ne transitent jamais par Worthify · Reçu envoyé automatiquement",
    preCheckoutVerdictProductName: "Verdict Worthify Basic",
    preCheckoutWarningBody: "Votre rapport est livré immédiatement dans votre navigateur dès confirmation du paiement. En confirmant, vous acceptez le démarrage immédiat de la prestation et renoncez à votre droit de rétractation de 14 jours selon le UK Consumer Contracts Regulations 2013.",
    preCheckoutWarningTitle: "Livraison numérique instantanée",
    premiumAnalysesBadge: "Analyses premium",
    premiumAnalysesLocked: "analyses premium verrouillées",
    premiumAnalysesTitle: "Toutes les analyses",
    premiumEstimateTitle: "Estimation prime annuelle",
    premiumHomeCopy: "Appuyez sur une tuile pour accéder à l'analyse complète. Appuyez sur Aperçu pour revenir au tableau de bord principal.",
    premiumHomeFooter: "Appuyez sur Aperçu ci-dessous pour revenir au tableau de bord principal",
    premiumHomeKicker: "Premium · Déverrouillé",
    premiumHomeTitle: "Les 15 analyses premium",
    premiumLabel: "Premium",
    premiumLockedTag: "Premium · Verrouillé",
    premiumPositioningSub: "Financement · Vol · Épave · VIN · Analyses IA · Estimation de marché",
    premiumPositioningTagline: "More Than HPI Check",
    premiumRangeLabel: "Prime typique",
    premiumUnlockedTag: "Premium · Déverrouillé",
    priceCheckLabel: "Contrôle du prix",
    priceFair: "Prix semble correct",
    priceFairBig: "PRIX CORRECT",
    priceNoData: "Aucun problème de prix détecté",
    priceOptionalHint: "Optionnel · déverrouille le contrôle du prix",
    priceOverpriced: "Prix semble élevé",
    priceOverpricedBig: "SURPAYÉ",
    priceScamTitle: "Vérification du prix",
    priceSubtitleDetected: "Basé sur les données de marché & l'historique.",
    priceSuspicious: "Prix semble suspect",
    priceSuspiciousBig: "PRIX SUSPECT",
    pricingFooterLine1: "Commencez par une recommandation gratuite.",
    pricingFooterLine2: "Passez au niveau supérieur uniquement si vous voulez des analyses approfondies et des informations véhicule premium.",
    pricingTransparencySub: "Trois niveaux. Payez uniquement pour la profondeur dont vous avez besoin.",
    pricingTransparencyTitle: "Tarification Simple. Transparence Totale.",
    proceedToPaymentCta: "Continuer vers le paiement — £4.99",
    rangeLabel: "fourchette",
    realisticRangeLabel: "Fourchette réaliste",
    recentSalesTitle: "Ventes comparables récentes",
    recurringAcross: "sur",
    recurringIgnoredBadge: "Ignoré sur plusieurs cycles",
    recurringIssuesLabel: "Problèmes Récurrents",
    recurringIssuesTimelineTitle: "Chronologie des problèmes récurrents",
    recurringYearsLabel: "années",
    regPlaceholder: "ex. AB12CDE",
    registrationLabel: "Immatriculation",
    riskSuffix: "RISQUE",
    runningCostsDisclaimer: "Estimations basées sur les moyennes britanniques. Les coûts réels varient selon le style de conduite, la localisation et l'assureur.",
    runningCostsModalTitle: "Coûts d'utilisation",
    safetyAxisAdult: "Occupant adulte",
    safetyAxisAssist: "Assistance à la sécurité",
    safetyAxisChild: "Occupant enfant",
    safetyAxisPedestrian: "Piéton / VRU",
    safetyBreakdownCopy: "Comment cette voiture se classe dans les quatre domaines de test Euro NCAP.",
    safetyBreakdownTitle: "Détail complet de la sécurité",
    safetyBreakdownUnlockCta: "Débloquer le détail complet — £4.99",
    safetyCardTitle: "Sécurité (Crash Test)",
    safetyCopy1: "Protection en cas de collision médiocre — 1★ Euro NCAP. Préoccupations importantes en matière de sécurité lors d'impacts réels ; envisagez une alternative plus sûre si possible.",
    safetyCopy2: "Protection en cas de collision faible — 2★ Euro NCAP. En dessous des normes de sécurité modernes, avec un risque mesurable lors d'impacts frontaux et latéraux.",
    safetyCopy3: "Protection en cas de collision moyenne — 3★ Euro NCAP. Acceptable pour son époque, mais les concurrents plus récents offrent une meilleure sécurité pour les occupants et les piétons.",
    safetyCopy4: "Performance crash-test solide — 4★ Euro NCAP. Un ensemble de sécurité bien conçu qui résiste bien aux tests d'impact modernes.",
    safetyCopy5: "Protection en cas de collision de premier ordre — 5★ Euro NCAP complet. Parmi les voitures les plus sûres de son époque, avec une forte protection pour les adultes, les enfants et les piétons.",
    safetyGoodCopy: "Performance crash-test solide pour son époque.",
    safetyHeadline1: "Sécurité médiocre",
    safetyHeadline2: "Sécurité faible",
    safetyHeadline3: "Sécurité moyenne",
    safetyHeadline4: "Sécurité solide",
    safetyHeadline5: "Sécurité excellente",
    safetyNoDataCopy: "Aucune évaluation Euro NCAP disponible pour ce modèle.",
    safetyOkCopy: "Performance crash-test moyenne pour son époque.",
    safetyPoorCopy: "Performance crash-test en dessous de la moyenne.",
    safetyTileAverage: "Sécurité crash-test moyenne pour son époque",
    safetyTileNoData: "Aucune donnée Euro NCAP",
    safetyTilePoor: "Protection en cas de collision en dessous de la moyenne",
    safetyTileStrong: "Sécurité solide — prouvée par les crash tests",
    scamAllClearCopy: "L'historique MOT et le kilométrage semblent cohérents.",
    scamAllClearTitle: "Aucun signal d'alarme détecté",
    scamCheck1: "Cohérence du kilométrage dans les tests MOT",
    scamCheck2: "Historique des défauts dangereux",
    scamCheck3: "Défauts récurrents ou ignorés",
    scamCheck4: "Longs intervalles MOT ou schémas suspects",
    scamChecklistTitle: "Ce que nous avons vérifié",
    scamDetectionLabel: "Vérifications anti-arnaque",
    scamFlaggedBadge: "Signalé",
    scamSafeBadge: "Aucun signal d'alarme",
    scamSafeValue: "Clair",
    scoreBadgeBad: "MÉDIOCRE",
    scoreBadgeGood: "BON",
    scoreBadgeOk: "MOYEN",
    scoreDisclaimer: "Les scores sont basés sur les données disponibles et ne garantissent pas l'état du véhicule.",
    scoreExpertsUnlockCta: "Débloquer l'analyse complète d'expert — £4.99",
    scoreScaleAverage: "Moyen",
    scoreScaleExcellent: "Excellent",
    scoreScaleGood: "Bon",
    scoreScalePoor: "Médiocre",
    scoreScaleTitle: "Échelle de score",
    scoreScaleVeryPoor: "Très médiocre",
    scoreScamHeader: "Arnaque détectée",
    scoreScamPriceCopy: "Le prix demandé est bien en dessous de la vraie valeur de marché de cette voiture. Indique presque toujours une fausse annonce, un véhicule volé ou une arnaque à l'entiercement — score forcé à 25/100 (À ÉVITER).",
    scoreScamPriceTitle: "Prix demandé bien en dessous de la vraie valeur de marché",
    scoreScamVinCopy: "Le VIN du vendeur décode une marque ou année différente de l'enregistrement DVLA. Ce schéma signale une voiture clonée ou une arnaque au VIN — score forcé à 25/100 (À ÉVITER).",
    scoreScamVinTitle: "Le VIN ne correspond pas à l'immatriculation",
    scoreShortBad: "Profil à haut risque — prévoyez une inspection minutieuse avant de vous engager.",
    scoreShortGood: "Historique solide — les chiffres soutiennent un achat en toute confiance.",
    scoreShortOk: "Signaux mitigés — gérable avec négociation, mais surveillez les problèmes récurrents.",
    seeFullExpertAnalysis: "Voir l'analyse complète d'expert",
    seenIn: "Vu dans",
    seenInMotPrefix: "Confirmé par MOT",
    sellerScriptTitle: "Que dire au vendeur",
    severityAdvisory: "Conseil",
    severityDangerous: "Dangereux",
    severityFailure: "Échec",
    severityMajor: "Majeur",
    severityMinor: "Mineur",
    severityNote: "Note",
    shareReportCopied: "Lien copié",
    shareReportCopyManual: "Copiez ce lien :",
    shareReportMessage: "Consultez ce rapport véhicule de Worthify",
    shareWithMechanicBadge: "Deuxième avis",
    shareWithMechanicCopied: "Lien copié — envoyez-le à votre mécanicien",
    shareWithMechanicCopy: "Envoyez l'immatriculation à un mécanicien ou ami de confiance. Ils recevront un lien instantané pour vérifier les résultats avant que vous ne vous engagiez.",
    shareWithMechanicCopyError: "Impossible de copier. Appuyez longuement pour partager manuellement.",
    shareWithMechanicCta: "Partager le lien",
    shareWithMechanicKicker: "Deuxième avis ? Envoyez ce rapport à un mécanicien de confiance.",
    shareWithMechanicMessage: "Salut — que penses-tu de cette voiture ? Worthify l'a analysée pour moi :",
    shareWithMechanicTitle: "Partagez ce rapport avec votre mécanicien",
    similarSoldDisclaimer: "Prix extraits des petites annonces britanniques pour la même marque/modèle et tranche d'années.",
    similarSoldModalTitle: "Voitures similaires vendues",
    simpleExplanationCardSub: "Une réponse de 60 secondes que tout le monde peut comprendre",
    simpleExplanationCardTitle: "Dois-je l\u2019acheter ?",
    simpleExplanationDisclaimer: "Ce résumé est fourni à titre indicatif uniquement — faites toujours inspecter la voiture par un mécanicien qualifié en personne avant l'achat.",
    simpleExplanationEmpty: "L'analyse est encore en préparation. Réessayez dans un instant.",
    simpleExplanationHeadline: "Dois-je l\u2019acheter ?",
    simpleExplanationKicker: "En clair",
    simpleExplanationLockedBadge: "Verrouillé — débloquez avec Premium",
    simpleExplanationLockedTitle: "Analyse complète",
    simpleExplanationSubhead: "Une réponse sans jargon basée sur l'analyse complète Worthify — rédigée pour que tout le monde puisse la comprendre.",
    simpleExplanationTitle: "Résumé en clair",
    simpleExplanationUnlockCta: "Débloquer l'explication complète — Premium",
    simpleExplanationVerdictTitle: "Voici la conclusion",
    socialProofCopy: "Utilisé par 50 000+ acheteurs de voitures au Royaume-Uni",
    sourceAiDesc: "Trois grands modèles de langage indépendants analysent les données en parallèle. Le Worthify Score utilise la médiane de leurs estimations afin qu'une seule hallucination ne puisse pas fausser le résultat.",
    sourceDvsaDesc: "Gouvernement britannique officiel — chaque résultat de test MOT, conseils et défauts dangereux.",
    sourceNhtsaDesc: "Base de données publique du gouvernement américain utilisée pour décoder le VIN du vendeur et détecter les arnaques de voitures clonées.",
    structuralFlagsLabel: "Signalements structurels",
    suggestedReductionKicker: "Réduction suggérée",
    suspiciousPriceCtaHint: "Appuyez pour voir pourquoi c'est important →",
    suspiciousPriceKicker: "Prix demandé anormalement bas",
    suspiciousPriceShort: "Le prix demandé de £{asking} ne représente que {pct}% de la valeur du marché (£{market}). Vérifiez avant tout paiement.",
    swipeDownHint: "Astuce : balayez vers le bas pour fermer",
    testRecorded: "test enregistré",
    testedIn: "Testé en",
    testsRecorded: "tests enregistrés",
    theftCheck1: "Police National Computer (PNC)",
    theftCheck2: "Registre des véhicules volés DVLA",
    theftCheck3: "MIAFTR (secteur de l'assurance)",
    theftCheck4: "Ports / signaux d'importation",
    theftChecksTitle: "Registres vérifiés",
    theftClean: "Aucun antécédent de vol",
    theftCleanCopy: "Aucune entrée trouvée dans le Police National Computer ou le registre des véhicules volés DVLA. Ce véhicule semble légitime.",
    theftFlagged: "Signalé volé",
    theftFlaggedCopy: "Ce véhicule est enregistré comme volé. NE POURSUIVEZ PAS — contactez la police au 101.",
    theftModalTitle: "Vérification vol & véhicule volé",
    tierBestValue: "MEILLEUR RAPPORT QUALITÉ-PRIX",
    tierFreeBasicInfo: "Informations de base du véhicule (Marque · Modèle · Année)",
    tierFreeBuyRec: "Recommandation d'achat",
    tierFreeCallout: "Parfait pour savoir si cette voiture mérite d'être examinée plus en détail.",
    tierFreeF1: "Recommandation d'achat Worthify (À éviter · Soyez prudent · Bonne affaire)",
    tierFreeFooter: "Sachez si le véhicule mérite un examen plus approfondi.",
    tierFreeFooterQ: "Devrais-je même considérer cette voiture ?",
    tierFreeIntro: "Obtenez une recommandation instantanée avant de dépenser le moindre sou.",
    tierFreeIntro2: "Obtenez une recommandation rapide avant de dépenser le moindre sou.",
    tierFreeLabel: "VÉRIFICATION GRATUITE",
    tierFreeMot: "Statut MOT (Réussi / Échoué / Actif)",
    tierFreeName: "Aide à la Décision Instantanée",
    tierFreeTax: "Statut de la Taxe",
    tierNewPill: "NOUVEAU",
    tierPremAiAdv: "Informations d'Achat IA (Avancées)",
    tierPremEverythingStd: "Tout de la Vérification Standard",
    tierPremF1: "Vérifications de Crédit en Cours",
    tierPremF10: "Analyse de Valeur Worthify (données premium)",
    tierPremF11: "Informations d'Achat Propulsées par IA (modèle premium)",
    tierPremF12: "Rapport PDF Premium (téléchargeable)",
    tierPremF2: "Vérifications de Véhicule Volé",
    tierPremF3: "Catégories d'Épave Assurance (A, B, S, N)",
    tierPremF4: "Vérification VIN (approfondie)",
    tierPremF5: "Vérification d'Identité du Véhicule",
    tierPremF6: "Détection d'Anomalie de Kilométrage",
    tierPremF7: "Évaluation des Risques du Véhicule",
    tierPremF8: "Historique des Changements de Plaque",
    tierPremF9: "Statut Import / Export",
    tierPremFinance: "Vérification de Crédit en Cours",
    tierPremIdentity: "Vérification d'Identité du Véhicule",
    tierPremImport: "Vérification Import / Export",
    tierPremMarket: "Évaluation du Marché",
    tierPremMileage: "Détection d'Anomalie de Kilométrage",
    tierPremMotHistory: "Historique MOT Détaillé",
    tierPremMulti: "Support Multilingue",
    tierPremNego: "Levier de Négociation",
    tierPremPdf: "Téléchargement du Rapport PDF",
    tierPremPlate: "Historique des Changements de Plaque",
    tierPremRiskAdv: "Évaluation des Risques (Avancée)",
    tierPremShare: "Partager Avec le Mécanicien",
    tierPremStolen: "Vérification de Véhicule Volé",
    tierPremVin: "Vérification VIN",
    tierPremWorthifyValue: "Valeur Worthify (Données Premium)",
    tierPremWriteOff: "Vérification d'Épave Assurance",
    tierPremiumBadge: "Meilleur rapport qualité-prix",
    tierPremiumCallout: "Tout ce dont vous avez besoin avant de dépenser des milliers pour un véhicule.",
    tierPremiumFooter: "Tout ce dont vous avez besoin avant de dépenser des milliers pour un véhicule.",
    tierPremiumFooterQ: "Quels risques dois-je connaître avant d'acheter ?",
    tierPremiumIncludes: "Tout de la vérification Standard, plus des renseignements véhicule avancés :",
    tierPremiumIntro: "More Than HPI Check.",
    tierPremiumIntro2: "Obtenez une intelligence complète du véhicule, la valeur marchande et l'analyse des risques.",
    tierPremiumLabel: "VÉRIFICATION PREMIUM",
    tierPremiumName: "More Than HPI Check",
    tierStandardCallout: "Comprenez pourquoi cela pourrait être un bon achat ou un achat risqué.",
    tierStandardFooter: "Comprenez ce que les données du véhicule signifient réellement.",
    tierStandardFooterQ: "Pourquoi est-ce un bon ou mauvais achat ?",
    tierStandardIntro: "Débloquez l'Analyse Complète Worthify.",
    tierStandardIntro2: "Débloquez l'analyse complète Worthify et comprenez les risques.",
    tierStandardLabel: "VÉRIFICATION STANDARD",
    tierStandardName: "Comprendre la Décision",
    tierStdAiExpl: "Analyse et Explications IA",
    tierStdEverythingFree: "Tout de la Vérification Gratuite",
    tierStdF1: "Worthify Buy Score Complet (0–100)",
    tierStdF10: "Évaluation du Marché Worthify",
    tierStdF2: "Informations de Consensus 3-IA Améliorées",
    tierStdF3: "Analyse MOT détaillée & tendances de défaillance",
    tierStdF4: "Points forts & faiblesses du véhicule",
    tierStdF5: "Analyse moteur & problèmes récurrents",
    tierStdF6: "Avis d'experts (Mécanicien · Concessionnaire · Économiste)",
    tierStdF7: "Arguments de négociation & estimations de réparation",
    tierStdF8: "Analyse crash test / sécurité",
    tierStdF9: "Partager avec un mécanicien",
    tierStdInitialRisk: "Évaluation initiale des risques",
    tierStdMot: "Analyse MOT détaillée",
    tierStdScore: "Worthify Buy Score (0–100)",
    tierStdStrengths: "Points forts & faiblesses du véhicule",
    topRiskLabel: "Risque principal",
    totalMilesLabel: "Kilométrage total",
    totalRangeLabel: "Autonomie totale",
    trustAisAgreed: "Accord des IA",
    trustDaysAgo: "il y a {n} jour",
    trustGdpr: "Conforme GDPR",
    trustHoursAgo: "il y a {n} h",
    trustHowItWorks: "Comment ça marche",
    trustIconAi: "Évaluation des risques par IA en qui vous pouvez avoir confiance",
    trustIconData: "Données fiables provenant de sources officielles britanniques",
    trustIconExplain: "Explications simples pour tous",
    trustIconOne: "Un seul rapport. Tout ce dont vous avez besoin.",
    trustIconUk: "Conçu pour les acheteurs britanniques et les véhicules britanniques",
    trustInstant: "Accès instantané",
    trustJustNow: "à l'instant",
    trustMinutesAgo: "il y a {n} min",
    trustSecure: "Sécurisé par Stripe",
    trustVerifiedBy: "Vérifié par",
    typeLabel: "Type",
    tyreBrakeModalTitle: "Usure des pneus et freins",
    tyresLabel: "Pneus",
    ulezChargesTitle: "Taxe journalière dans les zones britanniques",
    ulezCompliantShort: "Conforme",
    ulezCompliantTitle: "Conforme ULEZ",
    ulezModalTitle: "ULEZ / Clean Air",
    ulezNonCompliantShort: "Taxé",
    ulezNonCompliantTitle: "Non conforme ULEZ",
    ulezStatusLabel: "Statut ULEZ",
    ulezUnknownNote: "DVLA n'a pas retourné la classe d'émissions Euro pour cette plaque. Les diesels plus anciens peuvent être équipés rétroactivement, et les plaques personnalisées peuvent masquer un véhicule Euro 6 plus récent — vérifiez avec l'outil officiel de TfL ci-dessous.",
    ulezUnknownTitle: "Statut ULEZ non confirmé",
    ulezVerifyOnTfl: "Vérifier sur TfL — outil officiel",
    ulezVerifyShort: "Vérifier sur TfL",
    unknownCause: "défaillance majeure",
    unlockItemAccident: "Vérification de l'historique d'accidents",
    unlockItemAnomalies: "Anomalies & indicateurs de diagnostic",
    unlockItemCo2: "Émissions CO₂ & score écologique",
    unlockItemCrashTest: "Crash test & évaluation de sécurité",
    unlockItemDepreciation: "Prévisions de dépréciation",
    unlockItemEngineAnalysis: "Analyse moteur",
    unlockItemEngineExpert: "Verdict de l'expert moteur",
    unlockItemFailedMots: "Détail des échecs MOT",
    unlockItemFinance: "Vérification des crédits en cours",
    unlockItemImport: "Historique d'importation & exportation",
    unlockItemInsurance: "Groupe d'assurance",
    unlockItemMotHistory: "Historique MOT détaillé & défauts",
    unlockItemNegotiation: "Arguments de négociation (avec objectifs en £)",
    unlockItemOwners: "Anciens propriétaires & historique V5C",
    unlockItemPdf: "Rapport PDF téléchargeable",
    unlockItemPlatformExpert: "Verdict de l'expert plateforme",
    unlockItemPriceCheck: "Détection d'arnaque au prix et de surfacturation",
    unlockItemRecurring: "Détection de problèmes récurrents",
    unlockItemRiskExpert: "Verdict de l'expert risques",
    unlockItemRunningCosts: "Prévision des coûts d'utilisation sur 5 ans",
    unlockItemScore: "Worthify Score avec détail complet",
    unlockItemSimilarSold: "Véhicules similaires vendus",
    unlockItemSimpleExplanation: "Résumé acheter/éviter en clair",
    unlockItemTaxMot: "Statut DVLA taxe & MOT en direct",
    unlockItemTheft: "Vérification vol & véhicule volé",
    unlockItemTopRisk: "Résumé des risques principaux",
    unlockItemTyresBrakes: "Analyse usure pneus & freins",
    unlockItemUlez: "Verdict frais journaliers ULEZ & CAZ",
    unlockItemVin: "Recoupement VIN ↔ DVLA (détection de clone)",
    unlockItemWriteOff: "Vérification épave & assurance",
    unlockMoreDataCopy: "Paiement unique de £4.99 débloque moteur, négociation, anomalies, propriétaires, accident, financement, ULEZ, coûts d'utilisation, dépréciation et 6 vérifications supplémentaires + PDF complet.",
    unlockMoreDataLabel: "Débloquer plus de données",
    unlockMoreDataTitle: "Débloquer 15 analyses premium",
    useThisToNegotiate: "Utilisez ceci pour négocier",
    v5cIssuedLabel: "Dernier V5C",
    valueIn3Label: "Valeur dans 3 ans",
    valueIn5Label: "Valeur dans 5 ans",
    vehicleCo2Label: "Émissions CO₂",
    vehicleColourLabel: "Couleur",
    vehicleEngineLabel: "Moteur",
    vehicleEuroLabel: "Classe Euro",
    vehicleFuelLabel: "Carburant",
    vehicleInformationTitle: "Informations du véhicule",
    vehicleMakeLabel: "Marque",
    vehicleMarkedForExportLabel: "Marqué pour exportation",
    vehicleMileageLabel: "Kilométrage",
    vehicleModelLabel: "Modèle",
    vehicleRegDateLabel: "Première immatriculation",
    vehicleSpecsTitle: "Spécifications",
    vehicleTypeApprovalLabel: "Homologation type",
    vehicleUlezLabel: "ULEZ",
    vehicleV5CLabel: "Dernier V5C",
    vehicleYearLabel: "Année",
    verdictMainMedium: "PRUDENCE",
    verdictOverpricedSub: "Le prix demandé {subj} représente {pct}% de la valeur marché {median} — bien au-dessus du prix équitable.",
    verdictOverpricedTitle: "Trop cher vs marché",
    verdictPrefixHigh: "Mieux vaut",
    verdictPrefixLow: "Ressemble à une",
    verdictPrefixMedium: "Procéder avec",
    verdictScamSub: "Le prix demandé {subj} ne représente que {pct}% de la valeur marché {median} — profil typique d'arnaque.",
    verdictScamTitle: "Prix d'arnaque détecté",
    verdictShortAvoid: "À ÉVITER",
    verdictShortBeCautious: "SOYEZ PRUDENT",
    verdictShortGoodDeal: "BONNE AFFAIRE",
    verdictSuspiciousSub: "Le prix demandé {subj} ne représente que {pct}% de la valeur marché {median} — anormalement bas.",
    verdictSuspiciousTitle: "Prix anormalement bas",
    verifiedBy3Experts: "Vérifié par 3 experts indépendants",
    viewAnomalies: "Voir les anomalies",
    viewEngine: "Voir le moteur",
    viewFailedTests: "Voir les contrôles échoués",
    viewHistory: "Voir l'historique",
    viewIssues: "Voir les problèmes",
    viewNegotiation: "Négocier",
    vinInvalidChars: "Le VIN ne peut contenir que des lettres et des chiffres",
    vinInvalidLength: "Le VIN doit comporter exactement 17 caractères",
    vinOptionalHint: "Facultatif · 17 caractères · améliore la précision",
    vinUndecodableNote: "Votre VIN est enregistré mais n'a pas pu être décodé par la base de données publique américaine. De nombreux modèles exclusifs au Royaume-Uni n'y figurent pas — ce n'est pas un signal d'alerte en soi.",
    vinVerifiedBadge: "VIN vérifié",
    vinVerifiedCopy: "Le VIN du vendeur correspond à la marque et l'année DVLA. Aucun signal de clonage détecté.",
    wearBothCopy: "L'historique MOT montre des défauts répétés de pneus ET de freins. Prévoyez plus de £600 pour le remplacement dans les 6 premiers mois.",
    wearBrakeCopy: "L'historique MOT signale une usure des freins. Prévoyez £200-400 pour le remplacement des plaquettes/disques.",
    wearTyreCopy: "L'historique MOT signale une usure des pneus. Prévoyez £300-500 pour un jeu de 4 pneus.",
    wearWarningTitle: "Budget pour remplacement",
    whatThisMeans: "Ce que cela signifie",
    whatYouGetHeadline: "15 analyses premium + PDF complet",
    whatYouGetKicker: "Déblocage premium — £4.99",
    whatYouGetTitle: "Ce que vous obtiendrez",
    whyRiskTitle: "Pourquoi est-ce un risque ?",
    whyThisScore: "Pourquoi ce score ?",
    worthifyExpertName: "Expert Worthify",
    worthifyExpertRole: "Spécialiste historique véhicule · Consensus 3 IA",
    worthifyScoreLabel: "Worthify Score",
    writeOffCatA: "Ferraille uniquement",
    writeOffCatB: "Pièces détachées",
    writeOffCatN: "Non-structurel",
    writeOffCatS: "Dommage structurel",
    writeOffCategoriesTitle: "Vérification catégorie",
    writeOffClean: "Aucun enregistrement d'épave",
    writeOffFlagged: "Examen requis",
    writeOffModalTitle: "Vérification épave",
    writeOffScope: "Cat S · Cat N · Cat A · Cat B",
    yearLabel: "an",
    yearPlural: "ans",
    yearSingular: "an",
    yearlyBreakdownTitle: "Répartition annuelle",
    yearsLabel: "ans",
    yourLeverageTitle: "Votre levier",

    riskLevel_HIGH: "ÉLEVÉ",
    riskLevel_MEDIUM: "MOYEN",
    riskLevel_LOW: "FAIBLE",
    errorInvalidPlateChars: "Seules les lettres et chiffres sont autorisés sur les plaques UK.",
    legalEnNotice: "Ce document juridique est rédigé en anglais. Le service Worthify est exploité depuis le Royaume-Uni et soumis au droit britannique. Contactez support@worthify.co.uk pour toute clarification.",
    ninaButtonLabel: "Demander à Nina — Powered by Pine",
    ninaHeaderTitle: "Nina — Votre copilote d'achat auto",
    poweredByPine: "Powered by Pine",
    ninaGreeting: "Salut ! J'ai lu votre rapport pour {reg}. Vous voulez savoir si cette voiture vaut le coup ? Demandez-moi.",
    ninaInputPlaceholder: "Demandez à Nina…",
    ninaCallPitch: "Voulez-vous que j'appelle le vendeur pour négocier le prix ?",
    ninaCallSellerCta: "Appeler le vendeur — £2.99",
    ninaCalling: "Nina appelle le vendeur…",
    ninaCallDone: "Appel terminé",
    ninaCallMockSummary: "Le vendeur étudie £5 700 (au lieu de £6 000). Il vous demande de rappeler ce soir.",

    // ── Premium : vraies données de registre (Vehicle Data Global) ──
    gvdSourceNote: "Données en direct du registre DVLA",
    accidentSourceNote: "Données en direct de MIAFTR + historique véhicule DVLA",
    miaftrSourceNote: "Données en direct du MIAFTR (registre anti-fraude des assureurs)",
    financeSourceNote: "Données en direct du registre HPI / Experian (financement)",
    ownersKeeperLabel: "Propriétaire",
    ownersSinceLabel: "depuis",
    registryChecksTitle: "Vérifications du registre DVLA",
    importedFlagLabel: "Importé",
    importOutsideEuLabel: "Importé hors UE",
    importExportedLabel: "Exporté",
    importScrappedLabel: "Mis à la casse",
    ukSuppliedLabel: "Livré au Royaume-Uni",
    flaggedLabel: "Signalé",
    notFlaggedLabel: "Aucun signalement",
    liveValuationTitle: "Cote du marché en direct",
    valDealerForecourt: "Prix concessionnaire",
    valPrivateClean: "Vente privée (très bon état)",
    valPartExchange: "Reprise",
    valAuction: "Enchères",
    valMileageNote: "Estimé à {miles} miles · données du secteur en direct",
    tyreFitmentTitle: "Monte pneumatique d'origine",
    tyreFrontLabel: "Avant",
    tyreRearLabel: "Arrière",
    priceEvalLabel: "Évaluation du prix",
    mileageTileLabel: "Kilométrage",
    dvlaSubtitle: "Agence du permis et des véhicules",
    dvsaSubtitle: "Agence des normes des conducteurs et véhicules",
    dvsaOfficialData: "Données MOT officielles",
    poweredBy: "Powered by",
    gvdSubtitle: "Partenaire de données véhicules utilitaires",
    hpiSubtitle: "Plus de données qu'un contrôle HPI standard",
    errorInvalidRegistration: "Cette immatriculation semble incorrecte — vérifiez la plaque et réessayez.",

};
